import { render, staticRenderFns } from "./BudgetRequestLinkList.vue?vue&type=template&id=84323962&scoped=true&"
import script from "./BudgetRequestLinkList.vue?vue&type=script&lang=ts&"
export * from "./BudgetRequestLinkList.vue?vue&type=script&lang=ts&"
import style0 from "./BudgetRequestLinkList.vue?vue&type=style&index=0&id=84323962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84323962",
  null
  
)

export default component.exports